import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { File } from '@ionic-native/file';

import { IonicModule } from '@ionic/angular';

import { EfectivorespuestaPageRoutingModule } from './efectivorespuesta-routing.module';

import { EfectivorespuestaPage } from './efectivorespuesta.page';
import { SharedModule } from '../../shared/shared.module'; 

/*import { CurrencyPipe } from '@angular/common';
import localeCO from "@angular/common/locales/es-CO";
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeCO, "COP");*/

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    IonicModule,
    EfectivorespuestaPageRoutingModule,
    /*localeCO,
    CurrencyPipe*/
  ],
  declarations: [
    EfectivorespuestaPage,
    /*localeCO,
    CurrencyPipe*/
  ]
})
export class EfectivorespuestaPageModule {}
